import type { DiffDashboardColumn, DiffDashboardHotelRow } from "./diffTypes";

export type DiffDashboardMock = {
  objectId: string;
  objectName: string;
  columns: DiffDashboardColumn[];
  rows: DiffDashboardHotelRow[];
};

export const TEST_DIFF_OTA_OPTIONS = [
  { label: "Alean", value: "alean" },
  { label: "Сайт отеля", value: "travelline" },
  { label: "Яндекс", value: "yandex" },
  { label: "Островок", value: "ostrovok" },
];

export const TEST_DIFF_BOARD_OPTIONS = [
  { label: "Без питания", value: "RO" },
  { label: "Завтрак", value: "BB" },
  { label: "Полупансион", value: "HB" },
  { label: "Полный пансион", value: "FB" },
];

export const TEST_DIFF_PAYMENT_OPTIONS = [
  { label: "Предоплата", value: "prepaid" },
  { label: "Оплата в отеле", value: "pay_at_hotel" },
];

export const TEST_DIFF_DAYS_STAY_OPTIONS = [
  { label: "1 ночь", value: "1" },
  { label: "3 ночи", value: "3" },
  { label: "5 ночей", value: "5" },
];

const WEEKDAY_LABELS: Record<number, string> = {
  0: "Вс",
  1: "Пн",
  2: "Вт",
  3: "Ср",
  4: "Чт",
  5: "Пт",
  6: "Сб",
};

const MONTH_LABELS = ["янв", "фев", "мар", "апр", "май", "июн", "июл", "авг", "сен", "окт", "ноя", "дек"];

const createColumns = (startIsoDate: string, days: number): DiffDashboardColumn[] => {
  const start = new Date(`${startIsoDate}T00:00:00`);
  return Array.from({ length: days }, (_, index) => {
    const date = new Date(start);
    date.setDate(start.getDate() + index);
    return {
      isoDate: date.toISOString().slice(0, 10),
      shortLabel: `${String(date.getDate()).padStart(2, "0")}.${MONTH_LABELS[date.getMonth()]}`,
      weekDay: WEEKDAY_LABELS[date.getDay()],
    };
  });
};

export const TEST_DIFF_OBJECTS = [
  { label: "Mövenpick Resort And Spa Anapa Miracleon", value: "movenpick" },
  { label: "Zenith Resort Hotel & Spa Ultra All Inclusive", value: "zenith" },
  { label: "Alean Family Doville", value: "doville" },
];

const sharedColumns = createColumns("2026-03-20", 16);

export const TEST_DIFF_DASHBOARDS: DiffDashboardMock[] = [
  {
    objectId: "movenpick",
    objectName: "Mövenpick Resort And Spa Anapa Miracleon",
    columns: sharedColumns,
    rows: [
      {
        hotelName: "Grand autograph",
        prices: [13300, 13050, 0, 12490, 12150, 11970, 12320, 12980, 13500, 13820, 13650, 13240, 12880, 12420, 11890, 11540],
        deltas: [-1700, -1480, -1220, -950, -640, -320, 180, 540, 860, 1120, 940, 520, 170, -260, -610, -980],
      },
      {
        hotelName: "DOUBLETREE BY HILTON NOVOSIBIRSK",
        prices: [9405, 9020, 8750, 8550, 8340, 8203, 8420, 8870, 9661, 9934, 9610, 9240, 8890, 8470, 8120, 7860],
        deltas: [-320, -180, -90, 60, 140, 220, 310, 460, 854, 1020, 760, 430, 160, -80, -260, -410],
      },
      {
        hotelName: "DOMINA HOTEL NOVOSIBIRSK",
        prices: [8700, 8400, 7920, 7600, 7220, 7000, 7140, 7390, 7810, 8300, 8460, 8180, 7840, 7520, 7260, 7080],
        deltas: [-540, -380, -220, -120, 80, 210, 340, 470, 600, 760, 680, 420, 170, -60, -210, -330],
      },
      {
        hotelName: "COSMOS NOVOSIBIRSK",
        prices: [7055, 6840, 6410, 5980, 5725, 5525, 5690, 5950, 6210, 6480, 6360, 6120, 5880, 5620, 5490, 5380],
        deltas: [-210, -160, -120, -80, -40, 0, 110, 180, 240, 320, 260, 180, 90, -30, -85, -120],
      },
      {
        hotelName: "AZIMUT HOTEL SIBERIA",
        prices: [5130, 4860, 4420, 3980, 3600, 3330, 3510, 3890, 4380, 4820, 5010, 4700, 4260, 3920, 3610, 3480],
        deltas: [630, 510, 340, 140, -60, -180, 120, 280, 470, 630, 540, 310, 120, -90, -260, -330],
      },
      {
        hotelName: "RAMADA HOTEL & SUITES",
        prices: [6900, 7240, 7810, 1500, 8140, 7600, 7340, 7180, 7420, 7890, 8380, 8610, 8240, 7760, 7310, 7080],
        deltas: [-140, 220, 630, 1500, 1180, 700, 420, 260, 380, 710, 1160, 1380, 920, 430, 90, -120],
      },
      {
        hotelName: "MARINS PARK",
        prices: [5400, 5120, 4810, 4520, 4300, 4200, 4440, 4780, 5000, 5230, 5190, 4980, 4720, 4460, 4320, 4270],
        deltas: [400, 280, 140, 40, -110, -200, -90, 80, 200, 320, 250, 110, -40, -170, -210, -180],
      },
    ],
  },
  {
    objectId: "zenith",
    objectName: "Zenith Resort Hotel & Spa Ultra All Inclusive",
    columns: sharedColumns,
    rows: [
      {
        hotelName: "RIVIERA SUNRISE",
        prices: [11800, 11640, 11480, 11520, 11860, 12400, 12850, 0, 12450, 12100, 11890, 11720, 11610, 11840, 12280, 12620],
        deltas: [-400, -520, -640, -310, 120, 450, 700, 520, 340, 140, -20, -180, -260, 90, 360, 620],
      },
      {
        hotelName: "MIRAGE GRAND",
        prices: [9400, 9180, 9010, 9200, 9500, 9900, 10120, 9800, 9600, 9550, 9480, 9370, 9260, 9340, 9520, 9710],
        deltas: [-120, -240, -310, 0, 300, 400, 620, 430, 210, 120, 40, -80, -160, -40, 130, 290],
      },
      {
        hotelName: "MARITIME CLUB",
        prices: [8700, 8510, 8350, 8300, 8450, 8600, 9100, 9000, 8900, 8750, 8700, 8620, 8560, 8670, 8880, 9020],
        deltas: [-140, -220, -300, -180, 0, 140, 500, 420, 280, 110, 0, -70, -130, 40, 210, 340],
      },
      {
        hotelName: "PORTO MARE",
        prices: [7600, 7480, 7350, 7300, 7200, 7400, 7600, 7550, 7400, 7350, 7300, 7240, 7180, 7260, 7420, 7510],
        deltas: [90, -40, -150, -180, -300, -40, 250, 180, 40, 0, -70, -130, -180, -80, 60, 140],
      },
      {
        hotelName: "AQUA MARINE HOTEL",
        prices: [10300, 10180, 9970, 9840, 9920, 10100, 10560, 10740, 10620, 10480, 10220, 10040, 9960, 10080, 10420, 10680],
        deltas: [-180, -260, -340, -420, -180, 0, 320, 520, 460, 340, 160, 20, -80, 40, 280, 510],
      },
    ],
  },
  {
    objectId: "doville",
    objectName: "Alean Family Doville",
    columns: sharedColumns,
    rows: [
      {
        hotelName: "SUNSET PALACE",
        prices: [15400, 15200, 14950, 14800, 15100, 15700, 15900, 15820, 15400, 15000, 14950, 15120, 15460, 15840, 16020, 15780],
        deltas: [-220, -340, -450, -600, -210, 500, 700, 650, 310, -40, -120, 80, 340, 620, 760, 540],
      },
      {
        hotelName: "BEACH RESORT",
        prices: [13100, 13050, 12900, 12750, 12750, 250, 13500, 13450, 13300, 13050, 12800, 12720, 12860, 13140, 13380, 13220],
        deltas: [-80, -140, -150, -300, -300, 250, 500, 450, 300, 0, -100, -160, -60, 140, 260, 110],
      },
      {
        hotelName: "GARDEN PARK HOTEL",
        prices: [9900, 9800, 9650, 9500, 9600, 9800, 10150, 10020, 9950, 9800, 9700, 9620, 9690, 9860, 10040, 9960],
        deltas: [-120, -180, -250, -400, -190, 0, 350, 300, 150, 0, -60, -130, -40, 120, 260, 170],
      },
      {
        hotelName: "RIVIERA FAMILY CLUB",
        prices: [11400, 11250, 11100, 10980, 10980, 11300, 11650, 11700, 11500, 11320, 11150, 11080, 11190, 11460, 11640, 11520],
        deltas: [-60, -140, -220, -340, -340, 0, 260, 300, 150, 20, -70, -130, -30, 140, 260, 180],
      },
      {
        hotelName: "BLUE LAGOON RESORT",
        prices: [12450, 12280, 12060, 11920, 12040, 12320, 12740, 12810, 12680, 12440, 12220, 12160, 12240, 12580, 12840, 12720],
        deltas: [-130, -220, -340, -410, -260, 0, 280, 360, 260, 110, -40, -90, -20, 190, 420, 300],
      },
    ],
  },
];
